import apiClient from "../core/HttpClient";
import { CharityEventType } from "../models";

export default class CharityEventTypeService {
  url = "/CharityEventTypes";

  public async getCharityEventTypes(): Promise<CharityEventType[]> {
    return await apiClient.get(this.url).then((res) => res.data);
  }

  public async getCharityEventTypeById(id: string): Promise<CharityEventType> {
    return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
  }

  public async createCharityEventType(model: CharityEventType) {
    return await apiClient.post(this.url, model);
  }

  public async updateCharityEventType(model: CharityEventType) {
    return await apiClient.put(`${this.url}/${model.id}`, model);
  }

  public async deleteCharityEventType(id: number) {
    return await apiClient.delete(`${this.url}/${id}`);
  }
}
